export default __webpack_public_path__ + "static/media/bank_transfer.e0751d69.svg";